// The task layout designer: the interface builder over the detail layout of a task type.
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { z } from 'zod';
import { TaskLayoutDesigner } from '../../../../../features/tasks/designer/TaskLayoutDesigner';

export const Route = createFileRoute('/_focus/settings/task-types/$key/layout')({
  validateSearch: z.object({ variant: z.string().max(63).optional().catch(undefined) }),
  component: TaskLayoutRoute,
});

function TaskLayoutRoute() {
  const { key } = Route.useParams();
  const { variant } = Route.useSearch();
  const navigate = useNavigate();
  return (
    <TaskLayoutDesigner
      key={key}
      typeKey={key}
      variantId={variant}
      onVariant={(id) =>
        void navigate({
          to: '/settings/task-types/$key/layout',
          params: { key },
          search: id ? { variant: id } : {},
          replace: true,
        })
      }
      onBack={() => void navigate({ to: '/settings/task-types', search: { type: key, tab: 'layout' } })}
    />
  );
}
